<template>
  <v-autocomplete
    clearable
    dense
    item-text="name"
    item-value="id"
    outlined
    hide-details
    :disabled="disabled"
    :filter="customFilter"
    :items="availableTeams"
    :label="this.$t('common.team_one')"
    :loading="isLoadingTeams"
    :search-input.sync="searchTerms"
    :value="selectedTeamId"
    @change="$emit('change', $event)"
  >
  </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'RoutineTeamSelector',

  mixins: [mixin],

  props: {
    disabled: Boolean,
    selectedTeamId: String,
    routineSiteId: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.fetchAvailableTeams()
  },

  data() {
    return {
      isLoadingTeams: false,
      availableTeams: [],
      searchTerms: '',
    }
  },

  watch: {
    searchTerms: _.debounce(function(terms) {
      this.searchTerms = terms
      this.fetchAvailableTeams()
    }, 500),
  },

  computed: {
    ...mapGetters(['organizationId']),
  },

  methods: {
    async fetchAvailableTeams() {
      try {
        this.isLoadingTeams = true

        const params = {
          sort: { by: '_score', order: 'desc' },
        }

        if (this.searchTerms?.trim?.()) {
          params.terms = this.searchTerms
        }

        const response = await api.teams.getTeamsStream(
          this.organizationId,
          params
        )
        this.availableTeams =
          response.data?.results?.map(result => result?.team) ?? []
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isLoadingTeams = false
      }
    },

    customFilter() {
      // We delegate the responsibility of filtering to our back-end, so no additional local filter is needed.
      return this.availableTeams
    },
  },
}
</script>
